export default __webpack_public_path__ + "static/theListeningRoomMockup-1affdf158ddcde1ff6ffafc4b2d76340.png";